import React from 'react';

export default function SubmitButton({ text, className, submitting = false }) {
  return (
    <input
      className={`
        uppercase rounded-lg px-8 py-2 text-2xl font-extrabold cursor-pointer 
        ${className} 
        ${submitting ? 'opacity-50 curosr-not-allowed' : 'cursor-pointer'}
        `}
      type="submit"
      value={submitting ? 'submitting...' : text}
      disabled={submitting}
    />
  );
}
